import { render, staticRenderFns } from "./FailureReasons.vue?vue&type=template&id=7aa0e3d8&"
import script from "./FailureReasons.vue?vue&type=script&lang=js&"
export * from "./FailureReasons.vue?vue&type=script&lang=js&"
import style0 from "./FailureReasons.vue?vue&type=style&index=0&id=7aa0e3d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports